// extracted by mini-css-extract-plugin
export default {"wrapper":"ShortsAnimation_wrapper__txrdt","animationContainer":"ShortsAnimation_animationContainer__EmKDj","controls":"ShortsAnimation_controls__WGVJy"};